exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\r\n * Layout Variants\r\n */\n.sidebar-offcanvas .sidebar-container {\n  top: 65px;\n  transform: translate3d(-100%, 0, 0); }\n  .sidebar-offcanvas .sidebar-container .sidebar-header {\n    box-shadow: 0 0 0 #000; }\n\n.sidebar-offcanvas .header-container {\n  z-index: 30; }\n\n.sidebar-offcanvas .main-container,\n.sidebar-offcanvas .header-container {\n  margin-left: 0; }\n\n.sidebar-offcanvas.offcanvas-visible .sidebar-container {\n  transform: translate3d(0, 0, 0); }\n\n.no-csstransforms3d .sidebar-offcanvas .sidebar-offcanvas .sidebar-container {\n  margin-left: -262px; }\n\n.no-csstransforms3d .sidebar-offcanvas .sidebar-offcanvas.offcanvas-visible .sidebar-container {\n  margin-left: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout-variants.scss
// module id = 1166
// module chunks = 4